define('shared/util/checkout/coupon',[
    'shared/util/dispatchers/retrievers/state', 
    'shared/util/dispatchers/retrievers/query'
],
function (stateRetriever, queryRetriever) {
    return {
        get: function(){
            var couponCodeInUrl = null;
            var couponCodeInState = null;
            return queryRetriever('pcode', {caseSensitive: false})
                .then(function(data){ couponCodeInUrl = data; })
                .then(function(){ return stateRetriever('order.couponCode', {allowUndefined: true, doNotWait: true}); })
                .then(function(data){ couponCodeInState = data; })
                .then(function(){
                    var couponCode = null;
                    if(couponCodeInUrl && couponCodeInUrl.length > 0){
                        couponCode = couponCodeInUrl;
                    }
                    else if(couponCodeInState && couponCodeInState.length > 0){
                        couponCode = couponCodeInState;
                    }

                    return couponCode;
                });
        }
    };
});
